import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';

//importing modules
import auth from './modules/auth';
import app from './modules/app';
import company from './modules/company';
import user from './modules/user';
import film from './modules/film';
import screener from './modules/screener';
import files from './modules/files';
import filmRight from './modules/filmRight';
import subscription from './modules/subscription';
import plan from './modules/plan';
import tag from './modules/tag';
import country from './modules/country';
import pagination from './modules/pagination';
import impersonation from './modules/impersonation';
import customer from './modules/customer';
import consumer from './modules/consumer';
import page from './modules/page';
import venue from './modules/venue';
import revenue from './modules/revenue';
import monetization from './modules/monetization';
import screenerAccessLink from './modules/screenerAccessLink';
import coupon from './modules/coupon';
import analytics from './modules/analytics';
import booking from './modules/booking';
import affiliation from './modules/affiliation';
import filmMaker from './modules/filmMaker';
import program from './modules/program'


//Admin
import adminCompany from './modules/admin/company';
import adminFilm from './modules/admin/film';
import adminTag from './modules/admin/tag';
import adminUser from './modules/admin/user';
import adminSubscription from './modules/admin/subscription';
import adminDashboard from './modules/admin/dashboard';
import adminScreener from './modules/admin/screener';
import adminConsumer from './modules/admin/consumer';
import adminRevenue from './modules/admin/revenue';
import adminWidget from './modules/admin/widget';
import adminPage from './modules/admin/page';

Vue.use (Vuex);

export default new Vuex.Store ({
  state: {},
  actions: {
    resetAll({commit}) {
      commit ('app/reset');
      commit ('auth/reset');
      commit ('company/reset');
      commit ('film/reset');
      commit ('screener/reset');
      commit ('user/reset');
      commit ('filmRight/reset');
      commit ('tag/reset');
      commit ('adminTag/reset');
      commit ('adminUser/reset');
      commit ('adminSubscription/reset');
      commit ('plan/reset');
      commit ('subscription/reset');
      commit ('pagination/reset');
      commit ('impersonation/reset');
      commit ('consumer/reset');
      commit ('revenue/reset');
      commit ('monetization/reset');
      commit ('screenerAccessLink/reset');
      commit ('coupon/reset');
      commit ('adminScreener/reset');
      commit ('adminConsumer/reset');
      commit ('analytics/reset');
      commit ('venue/reset');
      commit ('booking/reset');
      commit ('affiliation/reset');
      commit ('adminWidget/reset');
      commit ('adminPage/reset');
    },
  },
  modules: {
    auth,
    app,
    company,
    user,
    film,
    screener,
    files,
    filmRight,
    subscription,
    plan,
    tag,
    country,
    pagination,
    adminCompany,
    adminFilm,
    adminTag,
    adminUser,
    adminSubscription,
    adminDashboard,
    adminRevenue,
    impersonation,
    customer,
    consumer,
    page,
    revenue,
    monetization,
    screenerAccessLink,
    coupon,
    adminScreener,
    adminConsumer,
    analytics,
    venue,
    booking,
    affiliation,
    adminWidget,
    adminPage,
    filmMaker,
    program
  },
  plugins: [
    createPersistedState ({
      key: 'app-il-film-screener',
    }),
  ],
});
